export default __webpack_public_path__ + "static/media/skills-light.90685112.svg";